const Instrument_Search_Input = document.getElementById("instrument-search-input");
const Instrument_Search_Results = document.getElementById("instrument-results");
let instrumentSearchRequestController;

const Search_Debounce = Debounce_Form(Get_Search_Results, 150);
const Search_Now = Debounce_Form(Get_Search_Results, 0);

if (Instrument_Search_Input && Instrument_Search_Results) {
  Instrument_Search_Input.addEventListener("input", Search_Debounce);
  Instrument_Search_Input.form.addEventListener("submit", (event) => {
    event.preventDefault();
    Search_Now();
  });

  for (const element of document.querySelectorAll(".instrument-search-input-button, .search__submit")) {
    element.addEventListener("click", Search_Now);
  }
}

window.addEventListener("keydown", Handle_Key_Down);

async function Get_Search_Results() {
  const searchQuery = Instrument_Search_Input.value;
  if (searchQuery.trim().length < 3 || !window.InstrumentGuides) return;

  if (instrumentSearchRequestController) instrumentSearchRequestController.abort();
  instrumentSearchRequestController = new AbortController();
  const requestController = instrumentSearchRequestController;
  Show_Search_Loading();

  try {
    const searchResults = await window.InstrumentGuides.search(
      searchQuery,
      requestController.signal
    );
    if (requestController !== instrumentSearchRequestController) return;
    Render_Search_Results(searchResults.results);
  } catch (error) {
    if (requestController === instrumentSearchRequestController) Hide_Search_Loading();
    if (error.name !== "AbortError") console.error("Error:", error);
  }
}

function Show_Search_Loading() {
  Instrument_Search_Results.setAttribute("aria-busy", "true");
  if (Instrument_Search_Results.querySelector(".instrument-search-loading")) return;

  const loading = document.createElement("div");
  loading.className = "instrument-search-loading";
  loading.setAttribute("role", "status");
  loading.setAttribute("aria-label", "Searching");
  loading.innerHTML = "<span></span><span></span><span></span>";
  Instrument_Search_Results.append(loading);
}

function Hide_Search_Loading() {
  Instrument_Search_Results.removeAttribute("aria-busy");
  const loading = Instrument_Search_Results.querySelector(".instrument-search-loading");
  if (loading) loading.remove();
}

function Render_Search_Results(list_results) {
  Hide_Search_Loading();
  const visibleResults = list_results.filter((result) => {
    try {
      return new URL(result.url, window.location.origin).pathname !== "/pages/instrument/is50";
    } catch (error) {
      return true;
    }
  });

  if (visibleResults.length === 0) {
    Instrument_Search_Results.innerHTML = "";
    let main_container = document.createElement("div");
    Instrument_Search_Results.append(main_container);

    let text_elem = document.createElement("p");
    text_elem.textContent = "No Results Found";
    main_container.append(text_elem);
  }
  if (visibleResults.length > 0) {
    Instrument_Search_Results.innerHTML = "";
    for (const result of visibleResults) {
      let main_container = document.createElement("div");
      main_container.classList.add(
        "instrument_card",
        "card",
        "color-scheme",
        "styled-item"
      );

      let anchor_container = document.createElement("a");
      anchor_container.href = result.url || "#";
      main_container.append(anchor_container);

      if (result.image_url) {
        let image_container = document.createElement("div");
        image_container.classList.add("instrument_media", "media");
        anchor_container.append(image_container);

        let instrument_img = document.createElement("img");
        instrument_img.src = result.image_url;
        instrument_img.alt = result.title || "";
        image_container.append(instrument_img);
      }

      let heading = document.createElement("h3");
      heading.textContent = result.title || result.handle || "Instrument Guide";
      anchor_container.append(heading);

      //let snippet = document.createElement("p")
      //snippet.textContent = ""
      //anchor_container.append(snippet)

      Instrument_Search_Results.append(main_container);
    }
  }
}

function Debounce_Form(callback, delay) {
  let timer;
  return function () {
    clearTimeout(timer);
    timer = setTimeout(() => {
      callback();
    }, delay);
  };
}

function Handle_Key_Down(event) {
  if (!event.repeat && event.key == "Enter") {
    let current_focus = document.activeElement;
    let current_element = current_focus.nextElementSibling;

    if (current_element != undefined) {
      current_element.focus();
    }
  }
}
